module.exports = __webpack_public_path__ + "static/media/title2.c6a2b2b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/imgs/title2.png
// module id = 1179
// module chunks = 0